import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';

import { Link } from 'core/routing';
import { useClientStore } from 'apps/hooks';

const StyledLink = styled(Link)`
  color: ${props => props.theme.color.wfBlack};
  &:hover {
    color: ${props => props.theme.color.wfBlue};
  }
`;

type PropsT = {
  name: string;
  params: object;
  target?: string;
  onClick?: () => void;
  children: React.ReactNode;
};

export const PortalLink = observer(
  ({ name: nameProp, params, children, onClick, target }: PropsT) => {
    let name = nameProp;
    const clientStore = useClientStore();
    let affix = null;
    if (clientStore.currentPortal === 'INTERMEDIATOR') {
      affix = 'intermediator';
    } else if (clientStore.currentPortal === 'MANUFACTURER') {
      affix = 'manufacturer';
    }
    if (affix) {
      if (name.startsWith('workspace')) {
        name = name.replace('workspace', `workspace.${affix}`);
      } else {
        name = [affix, name].join('.');
      }
    }
    return (
      <StyledLink name={name} params={params} onClick={onClick} target={target}>
        {children}
      </StyledLink>
    );
  },
);
